var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M6.061 16.156v-4.202H9.43v4.202c0 .462.379.84.842.84h2.526c.463 0 .842-.378.842-.84v-5.883h1.432c.387 0 .573-.479.278-.73L8.31 3.213c-.32-.285-.809-.285-1.129 0L.141 9.542c-.286.252-.11.731.278.731h1.432v5.883c0 .462.379.84.842.84h2.526c.463 0 .842-.378.842-.84z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#prefix__a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCAxNiAxNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0icHJlZml4X19hIiBkPSJNNi4wNjEgMTYuMTU2di00LjIwMkg5LjQzdjQuMjAyYzAgLjQ2Mi4zNzkuODQuODQyLjg0aDIuNTI2Yy40NjMgMCAuODQyLS4zNzguODQyLS44NHYtNS44ODNoMS40MzJjLjM4NyAwIC41NzMtLjQ3OS4yNzgtLjczTDguMzEgMy4yMTNjLS4zMi0uMjg1LS44MDktLjI4NS0xLjEyOSAwTC4xNDEgOS41NDJjLS4yODYuMjUyLS4xMS43MzEuMjc4LjczMWgxLjQzMnY1Ljg4M2MwIC40NjIuMzc5Ljg0Ljg0Mi44NGgyLjUyNmMuNDYzIDAgLjg0Mi0uMzc4Ljg0Mi0uODR6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTMpIj4KICAgICAgICA8dXNlIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI3ByZWZpeF9fYSIvPgogICAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };